import React, { useState } from "react";
import {
  Headline,
  SectionContent,
  Modal,
  Link,
  Text,
} from "../../../../components";

const SampleModal = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <SectionContent>
      <Modal
        show={showModal} // status de exibição inicial da modal
        onToggle={(stateModal) => {
          // handle acionado quando a modal muda de status e pode ser utilizado para alterar o estudo por hora do componente
          setShowModal(stateModal);
        }}
        onShow={() => {
          /* handle acionado quando a modal é exibida. */
        }}
        onClose={() => {
          /* handle acionaod quando a modal é fechada. */
        }}
        action={Link} // cria um componente de ação manual. por padrão a modal vem sem ação.
        actionText="Abrir Modal" // padrão nulo, será utilizado apenas se action As for setado
        actionProps={{ variant: "secondary" }} // padrão null, propriedade do elementType passado no action As
        opacityGlass={0.9} // define a opacidade do fundo de vidro, por padrão é 0.9
        headerModal={
          <Headline nivel="2" styleAs="5" text="Lorem ipsum dolor sit amet." />
        }
      >
        <Text>Lorem ipsum dolor sit amet consectetur adipisicing.</Text>
        <Text>Consectetur quisquam fugit omnis aperiam quam neque.</Text>
        <Text>Tempore qui, repellendus incidunt obcaecati ex non!</Text>
        <Text>
          Accusantium dolorum maxime quaerat debitis soluta! Consequuntur.
        </Text>
        <Text>Ipsum quas, illo temporibus nulla et inventore!</Text>
      </Modal>
    </SectionContent>
  );
};

SampleModal.propTypes = {};

export default SampleModal;
